import { render, staticRenderFns } from "./GDPRManage.vue?vue&type=template&id=684a3f29&"
import script from "./GDPRManage.vue?vue&type=script&lang=js&"
export * from "./GDPRManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports